// MUTATIONS
export const SET_LOGIN_FORM = 'setLoginForm';
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';

// ACTIONS
export const ACTION_LOGIN = 'login';

// GETTERS
export const GET_LOGIN_FORM = 'loginForm';
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';